import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './style.module.scss';
import Switch from '@/common/components/switch';
export default function SwitchField({ isOn, onToggle, label, description, style, }) {
    return (_jsxs("div", { className: styles['switch-field-row'], style: style, children: [_jsxs("div", { className: styles['switch-field-info'], children: [_jsx("div", { className: styles['switch-field-title'], children: label }), _jsx("div", { className: styles['switch-field-desc'], children: description })] }), _jsx(Switch, { isOn: isOn, onToggle: onToggle })] }));
}
